import { styled } from '@mui/material/styles';
import { AppBar as MuiAppBar, Toolbar as MuiToolbar, IconButton, Stack, Tooltip } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { AuthAvatarMenu } from 'components/layouts/main-layout/navbar/AuthAvatarMenu';
import { Notification } from 'components/layouts/main-layout/notification/Notification';
import { SearchSection } from './SearchSection';

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'wide',
})(({ theme, wide }) => ({
  width: '100%',
  zIndex: theme.zIndex.drawer,
  backgroundColor: theme.palette.common.white,
  boxShadow: 'none',
  padding: '0 6px',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(wide && {
    width: '100%',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Toolbar = styled(MuiToolbar)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: '6px',
  paddingRight: '20px',
}));

export const Navbar = ({ wide }) => (
  <AppBar
    position="absolute"
    wide={wide}
  >
    <Toolbar disableGutters>
      <SearchSection />
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
      >
        <Tooltip
          title="FAQ"
          placement="bottom"
          arrow
        >
          <IconButton aria-label="faq">
            <HelpOutlineOutlinedIcon sx={{ color: '#2e323a' }} />
          </IconButton>
        </Tooltip>
        <Notification />
        <AuthAvatarMenu />
      </Stack>
    </Toolbar>
  </AppBar>
);
